export {generatedInputNameAndId, generatedIndex} from './generatedInputNameAndId';
export {renderInputOutsideShadowRoot} from './injectHiddenInputOutsideShadowRoot';
